import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Coords } from 'components/AlignmentGuidelines';
import { useEditSceneModalStateContext } from 'containers/EditSceneModal/state';
import { captionsSizeSelector } from 'redux/modules/embed/selectors';
import { Size } from 'types';

export type UseCaptionsPositionProps = {
  captionsPositionStyle?: React.CSSProperties;
};

export default function useCaptionsPosition({
  captionsPositionStyle,
}: UseCaptionsPositionProps) {
  const captionsSize = useSelector(captionsSizeSelector);

  const {
    state: { previewDimensions },
  } = useEditSceneModalStateContext();

  // convert captions position style (css pixels) to rnd position (numeric pixels)
  const position: Coords<number> | undefined = useMemo(() => {
    if (!previewDimensions || !captionsPositionStyle) {
      return undefined;
    }

    return {
      x: parseFloat(String(captionsPositionStyle.left ?? 0)) || 0,
      y: parseFloat(String(captionsPositionStyle.top ?? 0)) || 0,
    };
  }, [captionsPositionStyle, previewDimensions]);

  // convert captions size (vw/vh) to rnd size (pixels)
  const size: Size<number> | undefined = useMemo(() => {
    if (!previewDimensions || !captionsSize) {
      return undefined;
    }

    return {
      width: captionsSize.width.toUnit('px', previewDimensions).value,
      height: captionsSize.height.toUnit('px', previewDimensions).value,
    };
  }, [captionsSize, previewDimensions]);

  return {
    position,
    size,
  };
}
